import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import {
    CheckCircleIcon,
    InformationCircleIcon,
    MinusCircleIcon,
    XIcon,
} from '@heroicons/vue/solid';
import { MetaPhoneNumber, MetaWhatsAppNumberPolicyPhone } from '@/types';
import PhoneNumberEligibilityState from './PhoneNumberEligibilityState.vue';
import { isPhoneEnabled } from '@/utils/whatsappMeta';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaPhoneNumberListItem',
  props: {
    phone: { type: Object as PropType<MetaPhoneNumber>, required: true },
    policyPhone: { type: Object as PropType<MetaWhatsAppNumberPolicyPhone | null>, default: null },
    canEnable: { type: Boolean, default: false },
},
  emits: ["activate", "approval"],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



const { locale, t } = useI18n();
const detailsOpen = ref(false);

const isEnabled = computed(() => isPhoneEnabled(props.policyPhone));
const axes = computed(() => [
    {
        owner: t('whatsappMeta.phoneAxis.meta'),
        ok: props.policyPhone?.isActive === true,
        value: t(
            props.policyPhone?.isActive
                ? 'whatsappMeta.phoneAxis.registered'
                : 'whatsappMeta.phoneAxis.notRegistered',
        ),
    },
    {
        owner: t('whatsappMeta.phoneAxis.mobcall'),
        ok: isEnabled.value,
        value: t(
            isEnabled.value
                ? 'whatsappMeta.phoneAxis.enabled'
                : 'whatsappMeta.phoneAxis.notEnabled',
        ),
    },
]);
const canActivate = computed(() => Boolean(props.policyPhone && !props.policyPhone.isActive));
const canEnablePhone = computed(() =>
    Boolean(props.policyPhone?.isActive && !isEnabled.value && props.canEnable),
);
const canDisable = computed(() => Boolean(props.policyPhone?.isActive && isEnabled.value));
const detailsId = computed(() => `phone-details-${props.phone.phoneNumberId}`);
const lastSyncedAt = computed(() => {
    if (!props.phone.lastSyncedAt) return t('whatsappMeta.phone.notSynchronized');
    return new Intl.DateTimeFormat(locale.value, {
        dateStyle: 'short',
        timeStyle: 'short',
    }).format(new Date(props.phone.lastSyncedAt));
});

const __returned__ = { props, locale, t, detailsOpen, isEnabled, axes, canActivate, canEnablePhone, canDisable, detailsId, lastSyncedAt, get CheckCircleIcon() { return CheckCircleIcon }, get InformationCircleIcon() { return InformationCircleIcon }, get MinusCircleIcon() { return MinusCircleIcon }, get XIcon() { return XIcon }, PhoneNumberEligibilityState }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})